import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {},
    typeSelector: {
      '& > div': {
        margin: '-4px 0',
        padding: '0 !important'
      },
      '& .hoi-poi-select__indicator-separator': {
        display: 'none'
      },
      '& .hoi-poi-select__placeholder, & .hoi-poi-select__single-value': _objectSpread(_objectSpread({
        position: 'relative',
        top: 'auto',
        transform: 'none'
      }, theme.typography.caption), {}, {
        color: theme.colors.neutral700
      }),
      '& .hoi-poi-select__value-container': {
        height: 32,
        padding: '0 4px 0 6px',
        marginRight: -8,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4
      },
      '& .hoi-poi-select__single-value': _objectSpread({
        maxWidth: '100%'
      }, theme.typography.caption),
      '& .hoi-poi-select__control': {
        padding: '2px 4px 2px 8px'
      },
      '& .hoi-poi-select__control--is-focused > div': {
        backgroundColor: theme.colors.neutral400
      },
      '& .hoi-poi-select__indicators': {
        height: 32,
        alignSelf: 'center',
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4
      }
    },
    typeSmall: {
      '& .hoi-poi-select__value-container': {
        height: 26
      },
      '& .hoi-poi-select__indicators': {
        height: 26
      }
    },
    typeSelectorWithValue: {
      '& .hoi-poi-select__dropdown-indicator': {
        display: 'none'
      }
    },
    typeSelectorInput: {
      minWidth: 'auto'
    },
    typeDivider: {
      width: 1,
      height: 23,
      backgroundColor: theme.colors.neutral400
    }
  };
});